/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import { PlusIcon, Trash2Icon, TriangleAlert } from "lucide-react";
import { useDocument, useDocumentReadOnly } from "../hook/useDocument";
import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const ActionColumn = ({
  data,
  parentKey,
  keyValue,
  review_required_row_no,
  temp_reviewed,
  warnings,
}: any) => {
  const [
    state,
    _setState,
    _searchAddress,
    _updateAddress,
    _searchSupplier,
    _updateSupplierMapping,
    _searchItemMaster,
    _updateItemMaster,
    mutationMasterData,
  ] = useDocument();

  // Void and deleted documents are read-only
  const isVoid = useDocumentReadOnly();

  return (
    <div>
      <div
        className={cn(
          "text-[14px] sticky top-0 text-transparent min-w-[10px] w-full  bg-gray-100 font-semibold z-30 text-left py-[5px]",
          temp_reviewed ? "h-[46px]" : "h-[46px]",
        )}
      >
        <Button
          variant={"default"}
          className=" border-green-500 p-1 w-auto h-auto ml-[5px]"
          size={"icon"}
          disabled={isVoid}
          onClick={() => {
            mutationMasterData({
              type: "add",
              payload: { parentKey, keyValue, data: data?.[0] },
            });
          }}
        >
          <PlusIcon />
        </Button>
      </div>
      {data?.map((item: any, index: number) => {
        if (item.is_deleted) {
          return null;
        }

        // const currentReviewed = temp_reviewed?.find(
        //   (crItem: any) => crItem.row_number === item.row_number,
        // );
        const hasWarnings = warnings?.find(
          (wItem: any) =>
            wItem?.row_number === item?.row_number &&
            wItem?.text &&
            wItem?.text !== "",
        );
        const warningList = hasWarnings ? hasWarnings?.text?.split(";") : [];
        return (
          <div
            className={cn(
              "w-full  relative h-[40px]",
              review_required_row_no.includes(item?.row_number) /*  &&
                currentReviewed.text === "false" */
                ? "bg-red-50"
                : "odd:bg-gray-50 even:bg-white",
            )}
            key={index}
          >
            <div className="text-[14px] p-[6px] flex items-center gap-2 justify-end">
              {hasWarnings ? (
                <Tooltip>
                  <TooltipTrigger asChild>
                    <TriangleAlert className="text-yellow-500" size={18} />
                  </TooltipTrigger>
                  <TooltipContent>
                    <ul className="details-list">
                      {warningList.map((item: any, index: number) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ul>
                  </TooltipContent>
                </Tooltip>
              ) : (
                ""
              )}
              <Button
                variant={"outline"}
                className="text-red-500 border-red-200 p-1 w-auto h-auto"
                size={"icon"}
                disabled={isVoid}
                onClick={() => {
                  mutationMasterData({
                    type: "remove",
                    payload: { index: index, parentKey, keyValue },
                  });
                }}
              >
                <Trash2Icon />
              </Button>
            </div>
          </div>
        );
      })}
    </div>
  );
};
